export default {
  en: {
    fileUpload: 'File upload',
    name: 'Name',
    btnSave: 'Save',
    btnCancel: 'Cancel',
    msgNameAlreadyExist:
      'Upload failed, please use different name. The specified is already stored.',
    msgCertificateUploaded: 'Certificate uploaded',
  },
};
